export default __webpack_public_path__ + "static/111-bf09ee9a8dcbf366774228609e257428.svg";